import { useEffect, useState } from 'react'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import MessageBox from '../MessageBox'
export default function QuestionAnswerFinal({ updateReports, setOpenFiKnowledge }) {
  const [score, setScore] = useState(null)

  useEffect(() => {
    fetchQuestionanswer()
  }, [])

  const fetchQuestionanswer = async () => {
    const url = urls.FinalFiKnowledgeQuestionary
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setScore(data.score)
      updateReports()
    }
  }

  return (
    <>
      {(score === 0 || score > 0) && (
        <MessageBox value={score} page={'Final'} setOpenFiKnowledge={setOpenFiKnowledge} />
      )}
    </>
  )
}
